import { image } from '../../design-system'

export * from './expand-contract-graphic'
export * from './get-involved-graphic'
export * from './landing-graphic'
export * from './tickets-graphic'
export * from './partner-orgs'
export * from './jump-arrow-graphic'
export * from './faqs-graphic'
export * from './back-icon'
export * from './flag-graphic'
export * from './detail-icon'
export * from './arrow'

export const IsoGrid = image({
  url: require('./iso-grid.gif'),
  objectFit: 'cover',
  parallaxDistance: -0.5,
})
